var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-header"}},[_c('a',{attrs:{"href":"https://smile-english.online/bookshelf"}},[_c('div',{staticClass:"mododru"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"cap"},[_vm._v("ホーム")])])]),_c('img',{attrs:{"src":require("@/assets/img/logos/DreaMagicLogoB.png"),"alt":""}})])
}]

export { render, staticRenderFns }